import React, { Component } from "react"
import FormField from "../FormField"
import { Switch } from "formik-antd"

export default class Platform extends Component {
  render() {
    return (
      <FormField name={this.props.name || "dont_pay"} label="Don't Pay">
        <Switch data-cy="invitation-dontpay" />
      </FormField>
    )
  }
}
